import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../assets/images/logo.png'
import { faArrowLeft, faHome, faList, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';

const MainLayout = ({ children }) => {

    const [hide, setHide] = useState(false)
    const navigate = useNavigate();
    const location = useLocation()
    const agentName = localStorage.getItem('username') || "Agent";
    useEffect(() => {
        if (location.pathname === '/') {
            setHide(true)
        }
    }, [location.pathname])

    const handleLogout = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        setTimeout(() => {
            window.location.href = '/'
        }, 1000);
    }

    return (
        <div className="w-full h-screen flex flex-col justify-center items-center" style={{ background: "linear-gradient(to bottom,  rgb(74, 96, 159) 30%, rgb(250, 250, 250) 0%)" }}>
            <div className=' h-[90vh]  lg:w-[35%] w-[100%] lg:p-0 p-5'>
                <div className=' flex  justify-center'>
                    <img src={logo} className='w-24 lg:w-32 mb-4' alt='' />
                </div>
                {hide && <h3 className='mb-3 text-xl lg:text-3xl font-bold text-white'>Welcome {agentName}</h3>}

                <div className={`${hide ? "h-[74vh] lg:h-[65vh]" : "h-[80vh] "}  overflow-auto bg-white rounded-lg shadow-md `}>
                    {!hide && <div className="flex justify-start m-2">
                        <button onClick={() => navigate(-1)} className="py-2 px-3 rounded-lg bg-gray-500 text-white hover:bg-gray-600 transition">
                            <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                            Kembali
                        </button>
                    </div>}
                    {children}
                </div>
            </div>
            <div className='flex justify-between mt-5 px-5 items-center w-full lg:w-[35%]'>
                <Link to="/">
                    <FontAwesomeIcon icon={faHome} className='text-gray-600 text-xl lg:text-2xl cursor-pointer' />
                </Link>
                <Link to={'/list'}>
                    <FontAwesomeIcon icon={faList} className='text-gray-600 text-xl lg:text-2xl cursor-pointer' />
                </Link>
                <Link to="/scanner" >
                    <FontAwesomeIcon 
                    icon={faQrcode} style={{fontSize: "4em", position: "relative", top: "-0.2em"}} 
                    className='text-gray-600 text-xl lg:text-2xl cursor-pointer' />
                </Link>

                {/* <Link to="/profile">
                    <FontAwesomeIcon icon={faUser} className='text-gray-600 text-xl lg:text-2xl cursor-pointer' />
                </Link> */}
                {/* <Link to='/chat'>
                    <FontAwesomeIcon icon={faMessage} className='text-gray-600 text-xl lg:text-2xl cursor-pointer' />
                </Link> */}
                <FontAwesomeIcon icon={faPowerOff} className='text-gray-600 text-xl lg:text-2xl cursor-pointer' onClick={handleLogout} />
            </div>

        </div>
    );
}
export default MainLayout;
